import { Locale } from 'chaika-enums';
import { PracticeContactViewModel, TranslationsData } from 'chaika-types';

import { OrganizationData } from 'chaika-frontend-types/frontend-cms';

export function getOrganizationName(
    organization: Pick<OrganizationData, 'name' | 'nameTranslations'>,
    locale?: Locale,
): string {
    return findTranslation(organization.nameTranslations, locale) ?? organization.name;
}

export function getPracticeName(practice: PracticeContactViewModel, locale?: Locale): string {
    const russianName = practice.nameRu ?? practice.practice ?? '';

    if (!fallsBackToEnglish(locale)) {
        return russianName;
    }

    return practice.nameEn ?? practice.nameEnShort ?? russianName;
}

function findTranslation(translations: TranslationsData[], locale?: Locale): string | undefined {
    const localeChain = fallsBackToEnglish(locale) ? new Set([locale, Locale.En]) : new Set([locale]);

    return [...localeChain]
        .map(item => translations.find(translation => translation.locale === item)?.value)
        .find(value => !!value);
}

function fallsBackToEnglish(locale?: Locale): boolean {
    return !!locale && locale !== Locale.Ru && locale !== Locale.Am;
}
